import api from "api"

export async function loadHouseholdPeople(store, household_id) {
  const people = await api.get(`households/${household_id}/people`)
  await store.update(state => {
    state.householdPersonIds[household_id] = people.map(person => person.id)

    people.forEach(person => {
      state.people[person.id] = person
    })
  })
}

export async function loadPerson(store, person_id) {
  const person = await api.get(`people/${person_id}`)
  await store.update(state => {
    state.people[person.id] = person
  })
}

export async function createPerson(store, { household_id, ...personDetails }) {
  const person = await api.post(
    `households/${household_id}/people`,
    undefined,
    personDetails
  )

  await store.update(state => {
    if (!state.householdAccountIds[household_id]) {
      state.householdPersonIds[household_id] = []
    }
    state.householdPersonIds[household_id].push(person.id)
    state.people[person.id] = person
    delete state.incomeBreakdowns[household_id]
  })
  return {
    personId: person.id
  }
}

export async function updatePerson(store, { id, ...values }) {
  const person = await api.patch(`people/${id}`, undefined, values)
  await store.update(state => {
    state.people[person.id] = person
    delete state.incomeBreakdowns[person.household_id]
  })
}

export async function deletePerson(store, { household_id, id }) {
  await api.delete(`people/${id}`)
  await store.update(state => {
    state.householdPersonIds[household_id].splice(
      state.householdPersonIds[household_id].findIndex(
        personId => personId === id
      ),
      1
    )
    delete state.people[id]
    delete state.incomeBreakdowns[household_id]
  })
}
